export const REKOMENDATELNYH_TEHNOLOGIY_PATH = '/legal/pravila-primeneniya-rekomendatelnyh-tehnologiy/';
export const SHOP_PATH = '/shop/';
